import { lerp } from "math";
import type { CSSProperties } from "vue";
import { globalDrawers, type IDrawer } from "~/composables/useDrawers";
import { type IStackItem } from "~/composables/useIDStack";
import { useSmoothAnimation } from "~/composables/useSmoothAnimation";
import { Drawer } from "./drawer";

const DRAWER_ANIMATION_DURATION = 0.45;

const DrawerWrapper = defineComponent<{ item: IStackItem<IDrawer> }>((props) => {
  return () => {
    return <Drawer style={{ pointerEvents: 'all' }} drawer={props.item}/>
  }
}, { props: ['item'] })


export const DrawerContainer = defineComponent(() => {
  const hook = globalDrawers;

  const animation = useSmoothAnimation();

  const hasDrawers = computed(() => hook.count.value > 0);

  watch(hasDrawers, (has) => {
    if (has) {
      animation.to(1.0, { duration: DRAWER_ANIMATION_DURATION });
    } else {
      animation.to(0.0, { duration: DRAWER_ANIMATION_DURATION });
    }
  }, { immediate: true })

  const wrapperStyle = computed((): CSSProperties => {
    const opacity = lerp(0.0, 100.0, animation.current.value);

    return {
      width: '100vw',
      height: '100vh',
      position: 'fixed',
      zIndex: 301,
      left: 0,
      top: 0,
      pointerEvents: 'none',
      opacity: `${opacity}%`,
      ...(opacity <= 0.000000001 ? {
        display: 'none',
      } : {})
    }
  })


  return () => {
    return <div class="grid grid-rows-[100%] grid-cols-[100%]" style={wrapperStyle.value}>
      {
        hook.drawers.value.map((item) => {
          return <DrawerWrapper item={item} key={`drawer-${item.id}`}/>
        })
      }
    </div>;
  }
});
